<div class="tag-ranking-chart" *ngIf="chartData.length > 0">
  <div class="chart-header">
    <h3>What Consumers Want</h3>
  </div>
  <div class="chart-container">
    <canvas #chartCanvas></canvas>
  </div>
</div>
